import { ISGInputLayerIds } from "fond/types";

export const isgInputLayers = [
  {
    key: ISGInputLayerIds.boundary,
    title: "Boundary",
    icon: "polygon" as const,
  },
  {
    key: ISGInputLayerIds.address,
    title: "Address",
    icon: "points" as const,
  },
];

export const getBaseName = (fileName: string): string => {
  return fileName.split(".")[0].toLowerCase();
};

export const fileNameToLayerId = (baseName: string): string | null => {
  const normalizedName = baseName.toLowerCase();
  if (normalizedName === "boundary") return ISGInputLayerIds.boundary;
  if (normalizedName === "address") return ISGInputLayerIds.address;
  return null;
};
